import QueryExporter from "./QueryExporter";

export default QueryExporter;
